import { NavigationSliderSecondaryProps } from 'component/NavigationSliderSecondary/NavigationSliderSecondary.types'
import NavigationSlider from '../../NavigationSlider/NavigationSlider'
import useNavigationSlider from '../../NavigationSlider/useNavigationSlider/useNavigationSlider'
import CardChart from './CardChart'
import { DataChart } from './ChartWrapper'
import { GroupedCardChartContainer } from './styles'

type GroupedCardChartProps = {
  data: Record<string, DataChart>
  iconSize?: number
  navigationProps?: {
    iconSize?: NavigationSliderSecondaryProps['iconSize']
    textVariant?: NavigationSliderSecondaryProps['textVariant']
    hasFixedNavigationButtonSize?: NavigationSliderSecondaryProps['hasFixedNavigationButtonSize']
  }
}

const GroupedCardChart = ({
  data,
  iconSize,
  navigationProps = {
    iconSize: 'extraSmall',
    textVariant: 'content-04',
    hasFixedNavigationButtonSize: true
  }
}: GroupedCardChartProps) => {
  const options = Object.keys(data).map((label) => ({
    value: label,
    label,
    color: '#303032'
  }))

  const {
    currentValue,
    currentIndex,
    disabledArrow,
    onNextClick,
    onPrevClick
  } = useNavigationSlider({ options })

  const cardChartData = data[currentValue]

  return (
    <GroupedCardChartContainer>
      <NavigationSlider
        options={options}
        currentIndex={currentIndex}
        onNextClick={onNextClick}
        onPrevClick={onPrevClick}
        disabledArrow={disabledArrow}
        {...navigationProps}
      />
      <CardChart
        data={cardChartData}
        chartModel='CardChart'
        iconSize={iconSize}
      />
    </GroupedCardChartContainer>
  )
}

export default GroupedCardChart
